import { Step1WritingInventoryPayload } from '../types/step1Writing';
import { payloadHasMeaningfulStep1Content } from './step1WritingArchive';

const KEY_PREFIX = 'rc-step1-emergency-v1-';

export interface Step1LocalBackupRecord {
  savedAt: string;
  payload: Step1WritingInventoryPayload;
  originalFileOmitted?: boolean;
}

function storageKey(userKey: string): string {
  return `${KEY_PREFIX}${userKey}`;
}

function slimPayloadForLocalStorage(
  payload: Step1WritingInventoryPayload
): { payload: Step1WritingInventoryPayload; originalFileOmitted: boolean } {
  let slim: Step1WritingInventoryPayload = { ...payload };
  let originalFileOmitted = false;
  let json = JSON.stringify(slim);
  if (json.length > 4_000_000 && slim.originalFileBase64) {
    slim = { ...slim, originalFileBase64: undefined };
    originalFileOmitted = true;
    json = JSON.stringify(slim);
  }
  return { payload: slim, originalFileOmitted };
}

/** Last-good copy on this device — updated after every successful server save. */
export function writeStep1LocalBackup(
  payload: Step1WritingInventoryPayload,
  userKey?: string
): void {
  if (!payloadHasMeaningfulStep1Content(payload)) return;
  const key = storageKey(userKey || 'anonymous');
  try {
    const { payload: slim, originalFileOmitted } = slimPayloadForLocalStorage(payload);
    const record: Step1LocalBackupRecord = {
      savedAt: new Date().toISOString(),
      payload: slim,
      originalFileOmitted,
    };
    localStorage.setItem(key, JSON.stringify(record));
  } catch {
    // Quota or private browsing — server archives remain primary
  }
}

export function readStep1LocalBackup(userKey?: string): Step1LocalBackupRecord | null {
  const key = storageKey(userKey || 'anonymous');
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Step1LocalBackupRecord;
    if (!parsed?.payload || parsed.payload._type !== 'step1_writing_payload') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearStep1LocalBackup(userKey?: string): void {
  try {
    localStorage.removeItem(storageKey(userKey || 'anonymous'));
  } catch {
    // ignore
  }
}
